import SectionHeader from "./SectionHeader";

const CARDS = [
  {
    category: "综艺复盘",
    title: "会说话的人赢在哪：综艺高情商名场面",
    excerpt: "同一场对话，为什么有人接得住、有人踩雷？拆解几个被反复讨论的高情商瞬间。",
    reads: "1.2w",
    minutes: 6,
    img: "https://readdy.ai/api/search-image?query=Warm%20flat%20vector%20illustration%20of%20a%20television%20studio%20stage%20with%20two%20hosts%20chatting%20and%20a%20glowing%20spotlight%2C%20coral%20and%20melon%20green%20accents%20on%20cream%20background%2C%20playful%20microphone%20and%20confetti%20shapes%2C%20clean%20minimal%20editorial%20art%2C%20cozy%20entertainment%20vibe&width=800&height=600&seq=topic-gua-02&orientation=landscape",
  },
  {
    category: "饭圈观察",
    title: "圈地自萌与路人视角：饭圈文化在聊什么",
    excerpt: "从应援、产粮到圈内黑话，试着用轻松视角聊聊不同圈层如何看同一件事。",
    reads: "9800",
    minutes: 5,
    img: "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20young%20fans%20cheering%20with%20lightsticks%20and%20handmade%20banners%2C%20pastel%20melon%20green%20and%20peach%20tones%20on%20soft%20cream%20background%2C%20floating%20hearts%20and%20stars%2C%20clean%20minimal%20vector%20editorial%20style&width=800&height=600&seq=topic-gua-03&orientation=landscape",
  },
  {
    category: "热梗速递",
    title: "这届网友的新词：热梗是怎么火起来的",
    excerpt: "从一部剧、一句话到一个表情包，热梗的传播路径其实有迹可循。",
    reads: "7600",
    minutes: 4,
    img: "https://readdy.ai/api/search-image?query=Warm%20flat%20vector%20of%20floating%20speech%20bubbles%20and%20comment%20boxes%20with%20like%20and%20share%20buttons%2C%20coral%20red%20and%20melon%20green%20accents%20on%20cream%20background%2C%20playful%20internet%20meme%20vibe%2C%20clean%20minimal%20editorial%20illustration&width=800&height=600&seq=topic-gua-04&orientation=landscape",
  },
  {
    category: "理性吃瓜",
    title: "真假消息怎么辨：吃瓜也要带点脑子",
    excerpt: "同一条消息 N 个版本？几个小习惯帮你少被带节奏，追得更安心。",
    reads: "6400",
    minutes: 7,
    img: "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20magnifying%20glass%20over%20documents%20and%20chat%20messages%20with%20a%20shield%20and%20checkmark%2C%20melon%20green%20and%20cream%20tones%2C%20trust%20and%20fact%20check%20concept%2C%20clean%20minimal%20editorial%20vector%20art&width=800&height=600&seq=topic-gua-05&orientation=landscape",
  },
];

const FEATURED = {
  category: "剧综专题",
  title: "本季爆款新剧，全网都在吵的 5 个名场面",
  excerpt:
    "从选角争议、剧情改编到售后营业，这波讨论从哪开始、又停在哪？我们用一份轻松的复盘，把讨论的来龙去脉摊开讲清楚，附上被反复提起的五个名场面和它背后的评论区生态。",
  reads: "3.4w",
  minutes: 8,
  tag: "持续跟进",
  img: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20flat%20vector%20illustration%20of%20a%20movie%20premiere%20scene%20with%20curtains%2C%20film%20clapperboard%20and%20sparkling%20spotlights%2C%20coral%20red%20and%20melon%20green%20accents%20on%20soft%20cream%20background%2C%20dramatic%20yet%20clean%20minimal%20editorial%20art%2C%20entertainment%20blockbuster%20mood&width=1200&height=700&seq=topic-gua-01&orientation=landscape",
};

export default function Topics() {
  return (
    <section id="guatian" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="今日瓜田速览"
          title="最近大家都在聊什么"
          desc="编辑部帮你把热闹的话题整理成一份好读的速览，追新瓜、补进度，一篇搞定。"
        />

        {/* Featured */}
        <a
          href="#joinform"
          className="group mt-10 flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-100 transition-colors hover:border-primary-200 lg:flex-row"
        >
          <div className="relative h-56 w-full overflow-hidden lg:h-auto lg:w-1/2">
            <img
              src={FEATURED.img}
              alt={`${FEATURED.title} 话题插画`}
              title={`九色吃瓜 · ${FEATURED.title}`}
              className="h-full w-full object-cover"
            />
            <span className="absolute left-4 top-4 rounded-full bg-secondary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-flashlight-line mr-1" aria-hidden="true"></i>
              {FEATURED.tag}
            </span>
          </div>
          <div className="flex flex-col justify-center gap-4 p-6 md:p-8 lg:w-1/2">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                {FEATURED.category}
              </span>
            </div>
            <h3 className="font-heading text-xl font-bold leading-snug text-foreground-900 md:text-2xl">
              {FEATURED.title}
            </h3>
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{FEATURED.excerpt}</p>
            <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-400">
              <span className="inline-flex items-center gap-1">
                <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                {FEATURED.reads} 热度
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-time-line" aria-hidden="true"></i>
                约 {FEATURED.minutes} 分钟读完
              </span>
              <span className="ml-auto inline-flex items-center gap-1 font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                进群一起蹲
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </a>

        {/* Cards */}
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((card) => (
            <a
              key={card.title}
              href="#joinform"
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-colors hover:border-primary-200"
            >
              <div className="relative h-40 w-full overflow-hidden sm:h-44">
                <img
                  src={card.img}
                  alt={`${card.title} 配图`}
                  title={`九色吃瓜 · ${card.title}`}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="flex flex-1 flex-col gap-3 p-5">
                <span className="inline-flex w-fit items-center rounded-full bg-accent-100 px-3 py-0.5 text-xs font-medium text-accent-800">
                  {card.category}
                </span>
                <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-900">
                  {card.title}
                </h3>
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{card.excerpt}</p>
                <div className="mt-auto flex flex-wrap items-center gap-3 pt-2 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {card.reads}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {card.minutes}min
                  </span>
                  <i className="ri-arrow-right-line ml-auto text-primary-500 transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}